__turbopack_context__.v({
  "container": "DonationImpactAnimalWelfare-module-scss-module__mgR8qW__container",
  "impact": "DonationImpactAnimalWelfare-module-scss-module__mgR8qW__impact",
  "smartdistributionlabel": "DonationImpactAnimalWelfare-module-scss-module__mgR8qW__smartdistributionlabel",
  "wrapper": "DonationImpactAnimalWelfare-module-scss-module__mgR8qW__wrapper",
});
